import type { UntitledIconData } from '@faceup/icons'

export const ucCaretRight: UntitledIconData = {
  prefix: 'custom',
  name: 'ucCaretRight',
  viewBox: '0 0 24 24',
  paths: [
    {
      shape:
        'M16.7766 11.5658L7.85156 3.86889C7.51875 3.58295 7.03125 3.84077 7.03125 4.30248V19.6962C7.03125 20.158 7.51875 20.4158 7.85156 20.1298L16.7766 12.433C17.032 12.2126 17.032 11.7861 16.7766 11.5658Z',
      fill: 'currentColor',
    },
  ],
}
